import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import Amplitude from '../utils/amplitudeHelper'
import PageWithBg from '../components/PageWithBg'
import LobbyOverlay from '../components/LobbyOverlay'
import LobbyEntry from '../components/LobbyEntry'
import config from '../config'
import buttons from '../images/navigation/button.png'
import materials from '../constants/exhibitionBooths'
import IframeModal from '../components/GlobalModals/IframeModal'
import PosterModal from '../components/GlobalModals/PosterModal'
import BoothNamecardModal from '../components/GlobalModals/BoothNamecardModal'
import VideoModal from '../components/GlobalModals/VideoModal'
import { useDispatch } from 'react-redux'
import { showGlobalModal } from '../ducks/layout'
import { toast } from 'react-toastify'

const PageWrapper = styled.div`
  #hotbtn {
    position: absolute;
    top: 81%;
    bottom: 3%;
    left: 50%;
    transform: translateX(-50%);
    img {
      height: 100%;
    }
  }
  
`
const HotButton = styled.div`
  ${(props) => props.css}
  position: absolute;
  cursor: pointer;
`

export default function LobbyPage({ currentUser }) {
  const [overlayTitle, setOverlayTitle] = useState('Select hall to enter:')
  const [overlay, setOverlay] = useState(null)
  const [nameCardModal, setNameCardModal] = useState(false)
  const [posterOpen, setPosterOpen] = useState(false)
  const [playVideo, setPlayVideo] = useState({})
  const [videoOpen, setVideoOpen] = useState(false)
  const [isOpen, setOpen] = useState(false)
  const dispatch = useDispatch()

  const showEntryOverlay = (destinations) => {
    setOverlay(destinations)
  }

  const hideOverlay = () => setOverlay(null)

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      hideOverlay()
    }
  }, [])

  const showHelpDesk = () => {
    toast("Event has ended.")
    // const cpt = window.chaport
    // cpt.on('ready', function () {
    //   cpt.setVisitorData({
    //     name: currentUser.fullName,
    //     email: currentUser.email,
    //   })
    //   cpt.open()
    // })
    // cpt.on('collapsed', function () {
    //   cpt.close()
    // })
    Amplitude.clickHelpDesk()
  }
  const clickHotButtons = (key) => {
    if (key === "info" ) handleInfoModal()
    if (key === "video" ) handleVideoModal()
    if (key === "image" ) handlePoster()
    if (key === "namecard" ) handleDropNameCard()
  }

  const handleInfoModal = () => {
    Amplitude.clickAgenda()
    dispatch(showGlobalModal('programme'))
  }
  const handleDropNameCard = () => {
    Amplitude.clickHotButtons('namecard')
    setNameCardModal(!nameCardModal)
  }
  const handlePoster = () => {
    Amplitude.clickHotButtons('poster')
    setPosterOpen(!posterOpen)
  }
  const handleVideoModal = () => {
    Amplitude.clickHotButtons('video')
    setVideoOpen(!videoOpen)
  }
  const handleModal = (video) => {
    Amplitude.playVideo(video)
    setPlayVideo({
      title: 'Video',
      link: video.url + '?autoplay=1',
    })
    setOpen(true)
    setVideoOpen(false)
  }

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit("Lobby")
  }, [currentUser.id])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  return (
    <PageWrapper>
      <PageWithBg bgImg={config.assets.lobby.landscape}>
        <LobbyOverlay
          overlayTitle={overlayTitle}
          overlay={overlay}
          hideOverlay={hideOverlay}
        />
        {config.lobbyEntries.map((entry) => {
          return (
            <LobbyEntry
              showHelpDesk={showHelpDesk}
              key={entry.id}
              setOverlayTitle={setOverlayTitle}
              showEntryOverlay={showEntryOverlay}
              {...entry}
            />
          )
        })}
        <div id="hotbtn">
          <img src={buttons} alt="hotbuttons"/>
          {
            Object.entries(materials).map(([key,value])=>{
              return (
                <HotButton css={materials[key].css} onClick={()=>clickHotButtons(key)}/>
              )
            })
          }
        </div>
        <BoothNamecardModal 
          currentUser={currentUser} 
          hideModal={()=>setNameCardModal(false)} 
          modal={nameCardModal} 
        />
        <VideoModal
          videos={materials['video'].videos}
          setVideoOpen={setVideoOpen}
          videoOpen={videoOpen}
          handleModal={handleModal}
        />
        {
          isOpen &&
          <IframeModal
            iframeOpen={isOpen}
            setIframeOpen={setOpen}
            iframe={playVideo}
          />
        }
        <PosterModal
          images={materials['image'].images}
          posterOpen={posterOpen}
          setPosterOpen={setPosterOpen}
        />
      </PageWithBg>
    </PageWrapper>
  )
}
